export enum CardType {
    PLASTIC = 'plastic',
    VIRTUAL = 'virtual'
}
